import { createAction, props } from '@ngrx/store';

import { SearchCommands } from '@features/search/domain/commands/search.commands';
import { ProductsWithResponseTimeByQuery, PromotedProductsByQuery, QueryFilters, QueryResult, RelatedTag, SearchType } from '@features/search/domain/models/search.models';

export const OpenSearchAction = createAction(
    SearchCommands.OPEN_SEARCH,
    props<{ reset?: boolean }>()
);
export const CloseSearchAction = createAction(SearchCommands.CLOSE_SEARCH);

export const LoadHtmlSearchSuccessAction = createAction(SearchCommands.LOAD_HTML_SEARCH_SUCCESS);
export const LoadHtmlSearchErrorAction = createAction(SearchCommands.LOAD_HTML_SEARCH_ERROR);

export const BlockScrollBodySearchAction = createAction(SearchCommands.BLOCK_SCROLL_BODY);
export const UnblockScrollBodySearchAction = createAction(SearchCommands.UNBLOCK_SCROLL_BODY);
export const TagRecordingSearchAction = createAction(SearchCommands.TAG_RECORDING_SEARCH);

export const ChangeTextSearchAction = createAction(
    SearchCommands.CHANGE_TEXT_SEARCH,
    props<{ text: string }>()
);

export const SetSectionSearchAction = createAction(
    SearchCommands.SET_SECTION_SEARCH,
    props<{ section: string }>()
);

export const ViewAllSearchAction = createAction(SearchCommands.VIEW_ALL_SEARCH);

export const SetSectionSearchSuccessAction = createAction(
    SearchCommands.SET_SECTION_SEARCH_SUCCESS,
    props<{ section: string; sectionLocal: string }>()
);

export const SetTypeSearchAction = createAction(
    SearchCommands.SET_TYPE_SEARCH,
    props<{ searchType: SearchType }>()
);

export const SaveTrendingQueriesSearchAction = createAction(
    SearchCommands.SAVE_TRENDING_QUERIES_SEARCH,
    props<{ trendingQueries: string[] }>()
);
export const SaveTrendingQueriesSearchErrorAction = createAction(SearchCommands.SAVE_TRENDING_QUERIES_SEARCH_ERROR);

export const SaveAutocompleteSearchAction = createAction(
    SearchCommands.SAVE_AUTOCOMPLETE_SEARCH,
    props<{ autocomplete: string[] }>()
);
export const SaveAutocompleteSearchErrorAction = createAction(SearchCommands.SAVE_AUTOCOMPLETE_SEARCH_ERROR);

// RECENT SEARCH START
export const SetRecentSearchAction = createAction(
    SearchCommands.SET_RECENT_SEARCH,
    props<{ recentSearch: string[] }>()
);
export const SaveRecentSearchAction = createAction(
    SearchCommands.SAVE_RECENT_SEARCH,
    props<{ recentSearch: string[] }>()
);
export const RemoveRecentSearchAction = createAction(
    SearchCommands.REMOVE_RECENT_SEARCH,
    props<{ item: string }>()
);
export const SaveRecentSearchErrorAction = createAction(SearchCommands.SAVE_RECENT_SEARCH_ERROR);
// RECENT SEARCH END

// RELATED TAGS START
export const GetRelatedTagsSearchAction = createAction(
    SearchCommands.GET_RELATED_TAGS_SEARCH,
    props<{ query: string }>()
);
export const SaveRelatedTagsSearchAction = createAction(
    SearchCommands.SAVE_RELATED_TAGS_SEARCH,
    props<{ relatedTags: RelatedTag[] }>()
);
export const SaveRelatedTagsSearchErrorAction = createAction(SearchCommands.SAVE_RELATED_TAGS_SEARCH_ERROR);
// RELATED TAGS END

// QUERY START
export const GetProductsArraySearchAction = createAction(
    SearchCommands.GET_PRODUCTS_ARRAY_SEARCH,
    props<{
        queryResults: ProductsWithResponseTimeByQuery;
        concatQueryResults: boolean;
        secondQueryBySection?: boolean;
        promotedResults?: PromotedProductsByQuery[];
    }>(),
);
export const GetProductsArraySearchErrorAction = createAction(SearchCommands.GET_PRODUCTS_ARRAY_SEARCH_ERROR);
export const SaveQuerySearchAction = createAction(
    SearchCommands.SAVE_QUERY_SEARCH,
    props<{
        queryResults: QueryResult[];
        fromQuerySearch: boolean;
        concatQueryResults: boolean;
        totalResults: number;
        isLastPage: boolean;
        secondQueryBySection: boolean;
    }>()
);
export const LoadNextPageSearchAction = createAction(
    SearchCommands.LOAD_NEXT_PAGE_SEARCH,
);
// QUERY END

export const SaveQueryFiltersAction = createAction(
    SearchCommands.SAVE_QUERY_FILTERS,
    props<{ queryFilters: QueryFilters }>(),
);

export const RemoveQueryFiltersAction = createAction(
    SearchCommands.REMOVE_QUERY_FILTERS,
);

export const RemoveQueryFilterAction = createAction(
    SearchCommands.REMOVE_QUERY_FILTER,
    props<{ filter: string }>(),
);

export const AddFilterToSearch = createAction(
    SearchCommands.ADD_FILTER,
    props<{ filter: string }>(),
);

export const QueryTaggingSearchSuccessAction = createAction(SearchCommands.QUERY_TAGGING_SEARCH_SUCCESS);

export const QueryTaggingSearchErrorAction = createAction(SearchCommands.QUERY_TAGGING_SEARCH_ERROR);

export const ClickTaggingSearchSuccessAction = createAction(SearchCommands.CLICK_TAGGING_SEARCH_SUCCESS);

export const ClickTaggingSearchErrorAction = createAction(SearchCommands.CLICK_TAGGING_SEARCH_ERROR);
